import { ArrowDown } from "@styled-icons/fa-solid";
import React from "react";

type Props = {
  direction: "ASC" | "DESC";
};

const SortIcon = ({ direction }: Props) => {
  return (
    <ArrowDown
      width={15}
      cursor="pointer"
      style={{
        transform: `rotate(${direction === "ASC" ? "180" : "0"}deg)`,
      }}
    />
  );
};

export default SortIcon;
